import Tab from "components/Tab";
import WebInstall from "../../../../contents/docs/integrate/_snippets/install-web.mdx";
import ReactInstall from "../../../../contents/docs/integrate/_snippets/install-react.mdx";
import NextJSInstall from "../../../../contents/docs/integrate/_snippets/nextjs/install-nextjs.mdx";
import GTMInstall from "../../../../contents/docs/integrate/_snippets/install-gtm.mdx";
import VueInstall from "../../../../contents/docs/integrate/_snippets/vuejs/install-vue.mdx";
import NuxtInstall from "../../../../contents/docs/integrate/_snippets/install-nuxt.mdx";
import SvelteInstall from "../../../../contents/docs/integrate/_snippets/install-svelte-client.mdx";
import WordPressInstall from "../../../../contents/docs/integrate/_snippets/install-wordpress.mdx";
import AstroInstall from "../../../../contents/docs/integrate/_snippets/install-astro.mdx";
import FramerInstall from "../../../../contents/docs/integrate/_snippets/install-framer.mdx";
import WebflowInstall from "../../../../contents/docs/integrate/_snippets/install-webflow.mdx";
import PhoenixInstall from "../../../../contents/docs/integrate/_snippets/install-phoenix.mdx";
import Wizard from "../../../../contents/docs/getting-started/_snippets/wizard.mdx";
import * as React from 'react';
export default {
  Tab,
  WebInstall,
  ReactInstall,
  NextJSInstall,
  GTMInstall,
  VueInstall,
  NuxtInstall,
  SvelteInstall,
  WordPressInstall,
  AstroInstall,
  FramerInstall,
  WebflowInstall,
  PhoenixInstall,
  Wizard,
  React
};